import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


// OBTENER TODOS LOS ENCABEZADO DE ORDENES - SCREEN
export const getOrdenesTrabajoEncabezado = async (data) => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraENCPorFecha`, "POST", data);
  return respuesta;
};

// OBTENER TODOS LOS ENCABEZADO DE ORDENES - SCREEN
export const getOrdenesTrabajoDetalle = async (data) => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraDETPorFecha`, "POST", data);
  return respuesta;
};

export const getOrdenesTrabajoDet = async () => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraDET`, "GET");
  return respuesta;
};


// OBTENER SIGUIENTE NUMERO DE OT
export const ObtenerSiguienteNoOrdenT = () => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/ObtenerSiguienteNoOrden", "GET");
  return respuesta;
};


// OBTIENE LOS DETALLES DE ORDENES DE TRABAJO POR NO.ORDEN
export const ObtenerDetalleOrdenesT = async (NoOrdenTrabajo) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraDETPorNoOrden`, 'POST', {NoOrdenTrabajo} )
  return result;
}


// OBTIENE LOS DETALLES DE ORDENES DE TRABAJO POR NO.ORDEN
export const ObtenerEncabezadoOrdenesT = async (NoOrdenTrabajo) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraENCPorNoOrden`, 'POST', {NoOrdenTrabajo} )
  return result;
}

// GUARDAR ORDENES DE TRABAJO
export const GuardarOrdenesTrabajo = (Encabezado, Detalle) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/GuardarEncabezado", "POST", {Encabezado, Detalle});
  return respuesta;
};

// EDITAR ORDENES DE TRABAJO
export const EditarOrdenesTrabajo = (Encabezado, Detalle) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/EditarOrdenTrabajo", "POST", {Encabezado, Detalle});
  return respuesta;
};

// ELIMINAR TAREA
export const EliminarTarea = (Detalle) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/EliminarItemOrden", "POST", {Detalle});
  return respuesta;
};

// ELIMINAR TAREA
export const EliminarOrdenT = (Detalle) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/EliminarOrden", "POST", {Detalle});
  return respuesta;
};

// OBTIENE LAS SUB TAREAS DE ORDENES DE TRABAJO POR NO.ORDEN DET
export const ObtenerSubTareas = async (NoOrdenTrabajoDet) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/OrdenesCompraDETPorNoOrdenTrabajoDet`, 'POST', {NoOrdenTrabajoDet} )
  return result;
}

// OBTIENE LAS ASIGNACIONES
export const getAsignaciones = async (IdOrdenDeTrabajoDet) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/Asignaciones`, 'POST', {IdOrdenDeTrabajoDet} )
  return result;
}

// GUARDAR ASIGNACIONES O SUBTAREAS
export const GuardarAsignaciones = (Encabezado) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/GuardarAsignaciones", "POST", {Encabezado});
  return respuesta;
};

// EDITAR ASIGNACIONES O SUBTAREAS
export const EditarAsignaciones = (Encabezado) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/EditarAsignaciones", "POST", {Encabezado});
  return respuesta;
};

export const EliminarAsignacion = (Encabezado) => {
  const respuesta = PrivateInterceptor("Mantenimiento/OrdenesTrabajo/EliminarAsignacion", "POST", {Encabezado});
  return respuesta;
};


export const getAsignacionesPorPersonal = async (IdPersonal) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/AsignacionesPorPersonal`, 'POST', {IdPersonal} )
  return result;
}

export const getAsignacionesTotales = async () => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/AsignacionesTotales`, 'GET' )
  return result;
}

export const getAsignacionesPorPersonalFilt = async (IdEstado, IdPersonal) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/AsignacionesPorPersonalFilt`, 'POST', {IdEstado, IdPersonal} )
  return result;
}

export const detenerTarea = async (IdAsignacion, Comentario, IdUser) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/DetenerTarea`, 'POST', {IdAsignacion, Comentario, IdUser} )
  return result;
}

export const iniciarTarea = async (IdAsignacion, Comentario, IdUser) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/IniciarTarea`, 'POST', {IdAsignacion, Comentario, IdUser} )
  return result;
}

export const terminarTarea = async (IdAsignacion, Comentario, IdUser) => {
  const result = await PrivateInterceptor(`Mantenimiento/OrdenesTrabajo/TerminarTarea`, 'POST', {IdAsignacion, Comentario, IdUser} )
  return result;
}